'use client'

import ConnectWallet from '@/components/layout/Navbar/ConnectWallet/connect-wallet'
import { Button } from '@/components/ui/button'
import { Drawer, DrawerContent, DrawerDescription, DrawerTitle } from '@/components/ui/drawer'
import useBoolean from '@/hooks/useBoolean'
import { cn } from '@/lib/utils'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { PiList, PiPlus } from 'react-icons/pi'
import { Logo } from './Logo'

const buttons: TNavbarButton[] = [
  {
    title: 'Trade',
    path: '/',
    active: true,
  },

  {
    title: 'Launchpad',
    path: '/launchpad',
    active: true,
  },
  {
    title: 'Vesting',
    path: '/vesting',
    active: true,
  },
]

export default function Navbar({ prices }: { prices: Record<string, number> }) {
  const mobileMenu = useBoolean(false)
  const route = usePathname()

  return (
    <div
      className={`w-full sticky top-0 z-[999] bg-[black]  border-b-[1px] border-b-border py-4 px-6 mx-auto flex items-center justify-between flex-row gap-4 min-h-[48px]`}
    >
      <div className="flex items-center gap-[60px]">
        <Logo />
        <div className={'flex items-center gap-6 justify-center max-[960px]:hidden'}>
          {buttons.map((button, index) => (
            <NavbarButton
              key={index}
              {...button}
            />
          ))}
        </div>
      </div>
      <div className={'flex items-center justify-end gap-3 h-10'}>
        <Button
          className={'size-10 min-[961px]:hidden'}
          onClick={mobileMenu.setTrue}
        >
          <PiList
            size={24}
            fill={'white'}
          />
        </Button>
        <Link
          href={'/create-center'}
          className="max-xs:hidden"
        >
          <Button className={' size-8'}>
            <PiPlus
              size={24}
              fill={'white'}
            />
          </Button>
        </Link>
        <div className="max-[435px]:hidden">
          <ConnectWallet prices={prices} />
        </div>
      </div>
      <Drawer
        open={mobileMenu.value}
        onOpenChange={open => mobileMenu.setValue(open)}
      >
  <DrawerContent className="bg-card border-none z-[99999]">
          <DrawerDescription></DrawerDescription>
          <DrawerTitle></DrawerTitle>
          <div className={'flex items-center gap-2 justify-center flex-col m-8'}>
            <Link
              href={'/create-center'}
              className="xs:hidden w-full"
              onClick={mobileMenu.setFalse}
            >
              <Button className={'size-10 w-full'}>
                Create
                <PiPlus
                  size={24}
                  fill={'white'}
                />
              </Button>
            </Link>
            <div className="min-[436px]:hidden w-full">
              <ConnectWallet prices={prices} />
            </div>
            {buttons.map((button, index) => (
              <NavbarButton
                key={index}
                {...button}
                className={'w-full'}
                action={mobileMenu.setFalse}
              />
            ))}
          </div>
        </DrawerContent>
      </Drawer>
    </div>
  )
}

type TNavbarButton = {
  title: string
  path: string
  active: boolean
  icon?: React.ReactNode
  disabled?: boolean
  className?: string
  action?: () => void
}

function NavbarButton(props: TNavbarButton) {
  const route = usePathname();
  const isActive = route === props.path;
  return (
    <Link
      href={props.path}
      className={`${cn('opacity-50 text-sm relative flex flex-col items-center', {
        'opacity-50 cursor-not-allowed': props.disabled,
        'opacity-100': props.active,
        'pl-2': props.icon,
      })}`}
      onClick={props.action}
    >
      {props.disabled && <p className={'text-primary font-semibold absolute text-[10px] top-[-12px] z-50'}>soon</p>}
      {props.icon && <div className={'rounded-full bg-primary size-8 grid place-content-center'}>{props.icon}</div>}
      <span>{props.title}</span>
      {isActive && (
        <div
          className="max-[960px]:hidden"
          style={{
            position: 'absolute',
            left: 0,
            bottom: -4,
            width: '100%',
            height: '2px',
            background: 'var(--primary, #eab308)',
            borderRadius: '2px',
          }}
        />
      )}
    </Link>
  )
}
